import { RefObject, SyntheticEvent, useEffect } from 'react'
import { useIMask } from 'react-imask'
import { MaskedPattern } from 'imask/esm/index'
import { addMaskToValue } from 'helpers/addMaskToValue'
import type { MaskedInputProps } from './MaskedInput.types'
import CustomTextField from '../CustomTextField'

export const MaskedInput = (props: MaskedInputProps) => {
  const { mask, onChange, type, defaultUnmaskedValue } = props
  // removing props that are not needed in CustomTextField
  const customTextFieldProps = { ...props }
  delete customTextFieldProps.mask
  delete customTextFieldProps.defaultUnmaskedValue

  const opts = {
    mask: new MaskedPattern({ mask }),
    lazy: true,
    eager: true // this option makes the mask to be deleted without effort
  }

  const {
    ref: iMaskRef,
    value: iMaskValue,
    setTypedValue,
    setValue,
    setUnmaskedValue
  } = useIMask<HTMLInputElement>(opts, {
    onAccept: (_, maskRef, e) => {
      if (e) {
        const modifiedTarget = {
          ...e.target,
          value: maskRef.unmaskedValue
        }
        onChange({
          ...e,
          target: modifiedTarget
        } as unknown as SyntheticEvent<HTMLInputElement>)
      }
    }
  })

  useEffect(() => {
    // Since we are not passing the real type as prop, this sets it directly to the input Ref
    if (iMaskRef.current) {
      iMaskRef.current.type = type
    }
  }, [])

  useEffect(() => {
    // we set the values from here when passing the default value for them to be passed down to the `CustomTextField` component
    setTypedValue(defaultUnmaskedValue)
    setValue(addMaskToValue(mask, defaultUnmaskedValue))
    setUnmaskedValue(defaultUnmaskedValue)
  }, [defaultUnmaskedValue])

  return (
    <CustomTextField
      {...customTextFieldProps}
      onChange={() => {}} // Instead of passing it here, OnChange is called by the onAccept fn passed to the useIMask hook
      type="text" // Passing type="text" so the masking is handled in this component instead of the Textfield component
      textfieldRef={iMaskRef as RefObject<HTMLInputElement>}
      value={iMaskValue}
    />
  )
}
